<page-header [action]="phActionTpl">
  <ng-template #phActionTpl></ng-template>
</page-header>
<full-content [fullscreen]="false">
  <nz-card>
    <st
      #st
      size="middle"
      [data]="datalist"
      [columns]="columns"
      [ps]="20"
      [scroll]="{ y: 'calc(100vh - 304px)' }"
    >
      <ng-template st-row="nameTpl" let-item let-index="index">
        <ng-container>
          <span style="cursor: pointer" (click)="showFile(item.name)">{{ item.name }}</span>
        </ng-container>
      </ng-template>
    </st>
  </nz-card>
</full-content>
